import React from "react";
import { useEffect, useMemo, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";

export const FormNuevoCliente = ({ objeto=null, postClientes }) => {

  const inputRules = {
    nombre: {
      required: {
        value: true,
        message: "Campo requerido",
      },
      maxLength: {
        value: 250,
        message: "Máximo de 250 caracteres",
      },
    },
    contacto: {
        maxLength: {
          value: 250,
          message: "Máximo de 250 caracteres",
        },
      },
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: useMemo(() => {
      return objeto;
    }, [objeto]),
  });

  const onSubmit = (data) => {
    postClientes(data)
  };

  return (
    <form id="FormNuevoCliente" onSubmit={handleSubmit(onSubmit)}>
            <div className="p-fluid formgrid grid pt-2">
                  <div className="field col-12">
                      <label htmlFor="nombre">Nombre</label>
                      <Controller
                          name="nombre"
                          control={control}
                          defaultValue=""
                          rules={inputRules.nombre}
                          render={({ field }) => (
                              <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.nombre })} rows={1} cols={30} 
                              onChange={(e) => field.onChange(e.target.value.toUpperCase())}
                              autoResize />
                          )}
                      />
                      {errors?.nombre && <small className="p-error">{errors.nombre.message}</small>}
                </div>
                <div className="field col-12">
                      <label htmlFor="contacto">Contacto</label>
                      <Controller
                          name="contacto"
                          control={control}
                          defaultValue=""
                          rules={inputRules.contacto}
                          render={({ field }) => (
                              <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.contacto })} rows={1} cols={30} autoResize />
                          )}
                      />
                      {errors?.contacto && <small className="p-error">{errors.contacto.message}</small>}
                </div>
          </div>
    </form>
  );
};

export default FormNuevoCliente;
